import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { FlightDropdownOption } from 'components/Flights/types'
import cn from 'clsx'

import Clickable from 'components/Common/Clickable'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'

const DropdownOption = styled(Clickable)`
  position: relative;
  display: flex;
  width: 100%;
  padding: ${rem(12)};
  background-color: ${props => props.theme.palette.neutral.eight};
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: ${props => props.theme.borderRadius.S};
  align-items: center;
  box-shadow: none;

  > * + * {
    margin-left: ${rem(12)};
  }


  &.selected {
    background-color: ${props => props.theme.palette.highlight.secondary.light};
  }

  &:disabled {
    color: ${props => props.theme.palette.neutral.four};
  }

  &:not(:disabled) {
    &:hover, &:active {
      background-color: ${props => props.theme.palette.neutral.seven};
    }

    &.mode-keyboard:focus {
      box-shadow: 0 0 0 2px ${props => props.theme.palette.neutral.five} inset;
    }
  }
`

// TODO: Replace with design system Tag
const InfoTag = styled(Caption)`
  padding: ${rem(2)} ${rem(8)};
  background-color: ${props => props.theme.palette.neutral.six};
  color: ${props => props.theme.palette.neutral.one};
  border: 1px solid ${props => props.theme.palette.neutral.eight};
  border-radius: ${props => props.theme.borderRadius.S};
`

interface Props {
  selected: boolean;
  option: FlightDropdownOption;
  'data-testid'?: string;
  onOptionSelect: (option: FlightDropdownOption) => void;
}

function FareDropdownOption(props: Props) {
  const { selected, option, onOptionSelect } = props

  const onSelect = () => {
    onOptionSelect(option)
  }

  return (
    <DropdownOption
      className={cn({ selected })}
      key={option.value}
      onClick={onSelect}
      disabled={option.disabled}
      data-testid={props['data-testid']}
    >
      <BodyText variant="large" wrap="truncate" weight="semi-bold">
        {option.label}
      </BodyText>
      {option.comingSoon && <InfoTag variant="medium" weight="bold" wrap="no-wrap">Coming soon!</InfoTag>}
    </DropdownOption>
  )
}

export default FareDropdownOption
